site.nav = {
	// Init navigation scripts
	init: function() {
		var $html = $('<div id="mMenu" role="navigation"></div>');
		var $mMenu = $('#mainmenu').find('.mmLevel1').clone().removeAttr('id');
		$mMenu.find('ul').removeAttr('id');
		$html.append($mMenu);
		$('body').append($html);

		// Add expand link to mobile menu
		$('.children', '#mMenu').prepend('<span class="expand"><i class="fa fa-chevron-down"></span>');
		$('.selectedLevel1','#mMenu').addClass('down');
		$('.selectedLevel2','#mMenu').addClass('down');
		$('.selectedLevel3','#mMenu').addClass('down');
		$('.selectedLevel4','#mMenu').addClass('down');
		//$('.selectedLevel2.children', '#mainmenu2').addClass('down');

		//$('.level2 > a', '.box_info, #mainmenu2').prepend('<span class="expand"><i class="fa fa-caret-right"></span>');
		site.nav.bind();
		site.nav.appendLanguage();
		//site.nav.appendQuickNav();
		//site.nav.appendSearchBox();
	},
	bind: function() {
		// Mobile menu toggle
		$('#mainmenuToggle').on('click touchstart',function(e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.nav.mobileToggle(e, menuOpen);

			$('#mMenu').on('click touchstart', function(e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open').on('click touchstart', function (e) {
				$('body').removeClass('mainmenu-open');
			});
		});

		// Expand in mobile menu
		$('.expand', '#mMenu').bind('click touchstart', function(e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
		/*
		$('#mainmenu2 .children .expand').bind('click', function(e) {
			console.log('asdf');
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
		*/
	},
	// Toggle mobile menu
	mobileToggle: function(e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
		$(this).toggleClass('open');
	},
	// Append language to site
	appendLanguage: function() {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', '#mMenu');

		var $html = $('<li class="ele-language si level1"></li>');
		$divisions.find('li').each(function() {
			var $li = $(this).clone();
			$html.append($li.find('a'));
		});

		$menu.append($html);
	},
	appendQuickNav: function() {
		var $qn = $('#qn ul');//.clone();
		var $menu = $('ul.mmLevel1', '#mMenu');
		var $qnContent = '';

		$qn.find('li').each(function() {
			$qnContent += '<li class="'+$(this).parent().attr('class')+'">'+$(this).clone().html()+'</li>';
			//$menu.append($(this).addClass('ele-qn si level1'));
		});
		$menu.append('<li class="ele-qn si level1"><ul class="menu special">'+$qnContent+'</ul></li>');
	},
	appendSearchBox: function() {
		var $menuItem = $('<li class="ele-search level1"></li>');
		var $menu = $('ul.mmLevel1', '#mMenu');
		var $searchBox = $('#searchBox').clone();
		$searchBox.attr('id','searchBox2');
		$searchBox.find('#searchForm').attr('id','searchForm2');
		$menuItem.append($searchBox);
		$menu.prepend($menuItem);
	}
};

site.inits.push('site.nav.init()');
